<template>
  <div class="head_banner">
    <!-- 预留位置放置导航组件 navigator -->
    <div class="banner-img-wrapper">
      <img
        class="banner_img"
        :src="imgUrl"
        alt
      />
    </div>

    <div class="banner_title_1 left title">
        <slot name="title_1_left"></slot>
    </div>
    <div class="banner_title_2 left  title">
        <slot name="title_2_left"></slot>
    </div>
    <div class="banner_title_1 center title" >
        <slot name="title_1_center"></slot>
    </div>
    <div class="banner_title_2 center title">
        <slot name="title_2_center"></slot>
    </div>
    <!-- 默认插槽 -->
    <slot></slot>
  </div>
</template>

<script>
// import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
export default {
  // mixins: [mixinName],
  // components: {},
  props: {
    imgUrl: {
      type: String,
      default: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/about_us.png'
    }
  },
  data () {
    return {
      key: 'value'
    }
  },
  created () {},
  methods: {},
  computed: {
    name () {
      return this.key
    }
  }
}
</script>

<style scoped lang="scss">
.head_banner {
  position: relative;
  color: #ffffff;

  .banner-img-wrapper {
    background-color:#253357;
  }
  .banner_img {
    width: 100%;
    height: vw(830);
    max-height: vw(837);
  }
  .title {
    position: absolute;
    line-height:vw(58);
  }
  .left{
    left:vw(212);
    text-align: left;
  }
  .center{
      @include cl;
  }
  .banner_title_1 {
    font-size: vw(68);
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: vw(104);
    top:vw(304);
  }
  .banner_title_2 {
    font-size: vw(48);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: vw(58);
    top:vw(414);
  }
}
@include isMobile() {
  .head_banner {
    .banner-img-wrapper {
      position: relative;
      height: rem(524);
      width: 100%;
      overflow: hidden;
    }

    .banner_img {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: initial;
      height: rem(524);
      min-height: rem(524);
    }

    .title {
      // position: absolute;
      line-height: rem(68);
    }
    .left {
      left: rem(40);
      // text-align: left;
    }
    .center {
      text-align: left;
        // @include cl;
      left: rem(40);
      transform: none;
    }
    .banner_title_1 {
      font-size: rem(42);
      // font-weight: bold;
      // color: rgba(255, 255, 255, 1);
      line-height: rem(68);
      top: rem(210);
    }
    .banner_title_2 {
      font-size: rem(38);
      // font-weight: 400;
      // color: rgba(255, 255, 255, 1);
      line-height: rem(52);
      top:rem(278);
    }
  }
}
</style>
